export default __webpack_public_path__ + "static/media/laundry1-beforeA-1024w.cf4a19df.webp";